import React, { useState } from "react";
import { Modal, Container, Row, Col } from "react-bootstrap";
import "./UnionEuropea.css";

const IMG_AXUDAS_ATRACCION = new URL('../../img/axudas/axudas_atraccion.jpg', import.meta.url).href;
const IMG_AXUDAS_PROMOCION_EXTERIOR = new URL('../../img/axudas/axudas_de_promocion_exterior.jpg', import.meta.url).href;
const IMG_AXUDAS_DIXITALIZACION = new URL('../../img/axudas/axudas_dixitalizacion_industria4_0.jpg', import.meta.url).href;
const IMG_AXUDAS_PROXECTOS_EMPRENDIMENTO = new URL('../../img/axudas/axudas_proxectos_de_emprendemento.jpeg', import.meta.url).href;
const IMG_AXUDAS_ACTIVIDADES_AGRICOLAS = new URL('../../img/axudas/axudas_actividades_non_agricolas.jpg', import.meta.url).href;
const IMG_AXUDAS_MAQUINARIA_EQUIPAMENTO = new URL('../../img/axudas/axudas_maquinaria_e_equipamento.jpg', import.meta.url).href;

const UnionEuropea = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [showModal, setShowModal] = useState(false);

    // Add your image sources here
    const images = [
        { thumbnail: IMG_AXUDAS_ATRACCION, fullRes: IMG_AXUDAS_ATRACCION, alt: "Axuda para a atracción de investimentos a Galicia, cofinanciada pola Unión Europea" },
        { thumbnail: IMG_AXUDAS_PROMOCION_EXTERIOR, fullRes: IMG_AXUDAS_PROMOCION_EXTERIOR, alt: "Axudas para a Execución de Accións de Promoción Exterior das Empresas Galegas" },
        { thumbnail: IMG_AXUDAS_DIXITALIZACION, fullRes: IMG_AXUDAS_DIXITALIZACION, alt: "Axudas do Igape á dixitalización Industria 4.0" },
        { thumbnail: IMG_AXUDAS_PROXECTOS_EMPRENDIMENTO, fullRes: IMG_AXUDAS_PROXECTOS_EMPRENDIMENTO, alt: "Axudas do Igape aos proxectos de investimento empresarial" },
        { thumbnail: IMG_AXUDAS_ACTIVIDADES_AGRICOLAS, fullRes: IMG_AXUDAS_ACTIVIDADES_AGRICOLAS, alt: "Axudas a Proxectos de Investimento en Actividades Non Agrícolas - 2023" },
        { thumbnail: IMG_AXUDAS_MAQUINARIA_EQUIPAMENTO, fullRes: IMG_AXUDAS_MAQUINARIA_EQUIPAMENTO, alt: "Axudas a Proxectos para a Adquisición de Maquinaria e Equipamento en Actividades Non Agrícolas" }
        // { thumbnail: "/path/to/thumbnail2.jpg", fullRes: "/path/to/fullres2.jpg", alt: "Image 2" },
        // Add more images as needed
    ];

    const handleImageClick = (image) => {
        setSelectedImage(image);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedImage(null);
    };

    return (
        <Container className="union-europea-container py-5">
            <h1 className="mb-4 text-center">Unión Europea</h1>
            
            <Row className="g-3">
                {images.map((image, index) => (
                    <Col key={index} xs={12} sm={6} md={4} lg={3}>
                        <div 
                            className="image-wrapper"
                            onClick={() => handleImageClick(image)}
                            role="button"
                            tabIndex={0}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    handleImageClick(image);
                                }
                            }}
                        >
                            <img 
                                src={image.thumbnail} 
                                alt={image.alt}
                                className="img-fluid"
                            />
                        </div>
                    </Col>
                ))}
            </Row>

            {/* Modal for full resolution image */}
            <Modal 
                show={showModal} 
                onHide={handleCloseModal}
                size="lg"
                centered
                className="image-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{selectedImage?.alt}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {selectedImage && (
                        <img 
                            src={selectedImage.fullRes} 
                            alt={selectedImage.alt}
                            className="img-fluid"
                        />
                    )}
                </Modal.Body>
            </Modal>
        </Container>
    );
}

export default UnionEuropea;